import { DeskHeader } from "@desk/components";
import { Layout, theme } from "antd";
import type { FC, PropsWithChildren } from "react";

import Icon from "@/assets/logo-white.png";

interface IRootLayout {
  Title: string;
}
export const RootLayout: FC<PropsWithChildren<IRootLayout>> = ({ children, Title }) => {
  const { token } = theme.useToken();

  return (
    <Layout style={{ height: "100vh" }}>
      <DeskHeader />
      <div className="absolute left-[30px] top-5">
        <ThemeTitle Title={Title} />
      </div>
      <Layout.Content style={{ backgroundColor: token.colorBgLayout }}>
        <div className="flex h-full flex-col overflow-auto">{children}</div>
      </Layout.Content>
    </Layout>
  );
};

const ThemeTitle = ({ Title }: { Title: any }) => (
  <div className="flex max-h-16 w-[300px] items-center">
    <div className="mr-12 hidden w-32 gap-2 text-white lg:flex">
      <img className="object-contain" src={Icon} />
      <div className="whitespace-nowrap text-base font-semibold">{Title}</div>
    </div>
  </div>
);
